import React from 'react';
import { Container } from 'reactstrap';
import NegotiationList from '../Negotiation/components/NegotiationList';

const NegotiationSupplierPage = () => {
  document.title = 'Negotiation';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <NegotiationList
            endpoint='/negotiation/supplier'
            detailBasePath='/apps-negotiation-supplier/dtl'
            listPath='/apps-negotiation-supplier/view'
            mode='supplier'
            title='NEGOTIATION'
            breadcrumbLabel='Negotiation'
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NegotiationSupplierPage;
